export default [
  {
    path: "/time-billings",
    component: () => import("@/components/General/DashboardHeader.vue"),
    children: [
      {
        path: "/time-billings",
        name: "time-billings",
        component: () => import("./TimeBilling.vue"),
      },
    ],
  },
];
